import React from 'react';
import { PrinterIcon, BedDoubleIcon, BathIcon, RulerIcon } from 'lucide-react';
import { brokerage, agent, listing, preparedDate } from '../../../data/reportPhilly';
// Formal letterhead header: the Berkshire Hathaway HomeServices Fox & Roach
// lockup top-left, "Marketing Report" meta top-right, then a square cabernet
// listing banner with the price in white serif.
export function HeaderV5() {
  return <header className="w-full" data-id="element-685" data-mp="2yz37jyd955wy">
      <div className="flex items-start justify-between gap-4" data-id="element-686" data-mp="2yyuvg8oye4mt">
        <div className="flex flex-col gap-2" data-id="element-687" data-mp="331zsvwu6fg4l">
          <img src={brokerage.logoLight} alt={brokerage.name} className="h-14 w-auto object-contain object-left sm:h-16" data-id="element-688" data-mp="32zn4b0twy7ik" />
          <p className="text-sm text-muted-foreground" data-id="element-689" data-mp="2u1uolvka4xun">
            Prepared by {agent.name} · {agent.title}
          </p>
        </div>
        <div className="text-right" data-id="element-690" data-mp="n8skqp8d62qv">
          <p className="font-display text-2xl font-semibold text-bhhs-cab" data-id="element-691" data-mp="s9yd2ly43nzv">
            Marketing Report
          </p>
          <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-muted-foreground" data-id="element-692" data-mp="371b0xowamhgn">
            Prepared
          </p>
          <p className="text-sm font-semibold text-foreground" data-id="element-693" data-mp="321olr9wwmr57">
            {preparedDate}
          </p>
          <button onClick={() => window.print()} className="mt-2 inline-flex items-center gap-1.5 border border-border px-2.5 py-1 text-xs font-medium text-bhhs-cab transition-colors hover:bg-secondary print:hidden" data-id="element-694" data-mp="3btaumzlrse4s">
            <PrinterIcon className="size-3.5" data-id="element-695" data-mp="2j5yi7i9bpmp7" />
            Download PDF
          </button>
        </div>
      </div>

      {/* thick cabernet rule under the header, like a printed letterhead */}
      <div className="mt-5 border-t-[3px] border-bhhs-cab" data-id="element-696" data-mp="2s4jyt7v8irnc" />

      {/* square cabernet listing banner */}
      <div className="mt-6 flex flex-col gap-3 bg-bhhs-cab px-6 py-5 text-white sm:flex-row sm:items-center sm:justify-between" data-id="element-697" data-mp="ccw7bryzprbx">
        <div data-id="element-698" data-mp="7hgsawp8xpdx">
          <h1 className="font-display text-2xl font-semibold leading-tight sm:text-3xl" data-id="element-699" data-mp="3172mt64hitny">
            {listing.address}, {listing.cityState}
          </h1>
          <p className="mt-1.5 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-white/75 sm:text-sm" data-id="element-700" data-mp="364lzw2pg50eb">
            <span className="inline-flex items-center gap-1" data-id="element-701" data-mp="3a8jz0derub7d">
              <BedDoubleIcon className="size-3.5" data-id="element-702" data-mp="3f73kydtd7mzq" /> {listing.beds} BD
            </span>
            <span aria-hidden data-id="element-703" data-mp="2ih4eqq0ot0kb">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-704" data-mp="2ii5tb4gww56s">
              <BathIcon className="size-3.5" data-id="element-705" data-mp="2mheli4wazv08" /> {listing.baths} BA
            </span>
            <span aria-hidden data-id="element-706" data-mp="2rhj1zux7opqg">·</span>
            <span className="inline-flex items-center gap-1" data-id="element-707" data-mp="2rghh6yqe8ovj">
              <RulerIcon className="size-3.5" data-id="element-708" data-mp="2w7psk0baakbc" /> {listing.sqft} sqft
            </span>
            <span aria-hidden data-id="element-709" data-mp="1yslkhu0tqwyr">·</span>
            <span data-id="element-710" data-mp="1yrkbdv3dckjo">Listed May 1, 2026</span>
          </p>
        </div>
        <p className="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl" data-id="element-711" data-mp="23rf29yn59a4q">
          {listing.price}
        </p>
      </div>
    </header>;
}